// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1MaNQ","ranges":"BmiRanges_ranges__3lTc-"};